<div>
  <div class="sub-heading mt-0">
    {{HeadingLabel}}
  </div>

  <div class="mx-2-5 mb-3-5">

    <div class="sub-content-description my-1">
      {{SubHeadingLabel}}
    </div>

    <div [formGroup]="contactSupportForm">

      <mat-error class="mat-form-field" style="font-size: 1rem;" *ngIf="contactSupportForm.controls.emailMismatch.errors != null"> {{emailMismatchError}}</mat-error>
      <br />
      <mat-form-field class="width-100">
        <mat-label class="textBox-text">{{emailLabel}}</mat-label>
        <input matInput maxlength="100" appAutoFocus class="textBox-text" type="text" formControlName="contactSupportEmail" (keyup.enter)="enterKey()" />
        <mat-error class="mat-form-field" style="font-size: 1rem;" *ngIf="contactSupportForm.controls.contactSupportEmail.errors != null"> {{emailError}}</mat-error>
      </mat-form-field>

      <mat-form-field class="width-100">
        <mat-label class="textBox-text">{{emailConfirmationLabel}}</mat-label>
        <input matInput maxlength="100" class="textBox-text" type="text" formControlName="contactSupportEmailVerify" (keyup.enter)="enterKey()" />
        <mat-error class="mat-form-field" style="font-size: 1rem;" *ngIf="contactSupportForm.controls.contactSupportEmailVerify.errors != null"> {{verifiedEmailError}}</mat-error>
      </mat-form-field>

      <mat-form-field class="width-100">
        <div class="textarea-wrapper flex-display">
          <textarea class="textBox-text textarea-padding" formControlName="contactSupportEmailBody" type="text" matInput cdkTextareaAutosize
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="6" maxlength="4000" (input)="emailBodyChange($event.target.value)" placeholder={{textarealabel}}></textarea>
          <div class="remaning">{{remainingText}}/4000</div>
        </div>
        <mat-error class="mat-form-field" style="font-size: 1rem;" *ngIf="contactSupportForm.controls.contactSupportEmailBody.errors != null"> {{emailBodyError}}</mat-error>
      </mat-form-field>
      <div class="recaptcha" *ngIf="(siteKey!='' && (LoginPageURL == true))">
        <form [formGroup]="aFormGroup">
          <ngx-recaptcha2 #captchaElem
                          id="recaptchacontactsupport"
                          siteKey={{siteKey}}
                          (success)="resolved($event)"
                          (error)="errorrecap()"
                          (expire)="errorrecap()"
                          formControlName="recaptcha">
          </ngx-recaptcha2>
        </form>
      </div>
      <div class="flex-display" style="margin:1em 0 0 0;">
        <button mat-button [ngClass]="((LoginPageURL==true) ? 'btn-primary-disabled-basic':'btn-primary-basic cursor-pointer')"  id="submit"  (click)="contactSupportSubmit()">{{submitLabel}}</button>
      </div>

    </div>
  </div>
</div>




